var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskOverview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8037 32.5051V44.2685C50.8037 45.8164 49.4576 47.0711 47.7969 47.0711H3.998C2.33735 47.0711 0.991211 45.8164 0.991211 44.2685V3.4451C0.991211 1.89727 2.33735 0.642578 3.998 0.642578H47.7969C49.4576 0.642578 50.8037 1.89727 50.8037 3.4451V29.2355",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3799 9.04883H50.804",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.991211 9.04883H9.87167",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50144 6.24588C6.33174 6.24588 7.00484 5.61852 7.00484 4.84462C7.00484 4.07073 6.33174 3.44336 5.50144 3.44336C4.67114 3.44336 3.99805 4.07073 3.99805 4.84462C3.99805 5.61852 4.67114 6.24588 5.50144 6.24588Z",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5151 6.24588C12.3454 6.24588 13.0185 5.61852 13.0185 4.84462C13.0185 4.07073 12.3454 3.44336 11.5151 3.44336C10.6848 3.44336 10.0117 4.07073 10.0117 4.84462C10.0117 5.61852 10.6848 6.24588 11.5151 6.24588Z",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5288 6.24588C18.3591 6.24588 19.0322 5.61852 19.0322 4.84462C19.0322 4.07073 18.3591 3.44336 17.5288 3.44336C16.6985 3.44336 16.0254 4.07073 16.0254 4.84462C16.0254 5.61852 16.6985 6.24588 17.5288 6.24588Z",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8555 17.8456L21.8815 12.8872C21.9229 12.7929 22.0663 12.7928 22.1079 12.887L24.1156 17.8456",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4873 16.6094H23.4939",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3408 12.8164V17.8456",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2435 12.8809L33.5137 15.2197L36.4351 17.8467",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4488 13.3334C30.4488 13.3334 29.4806 12.5749 28.3388 12.8954C27.2904 13.1897 27.1438 14.3165 27.9022 14.7774C27.9022 14.7774 28.6465 15.0869 29.472 15.3707C31.459 16.0538 30.6031 17.8457 29.0034 17.8457C28.2023 17.8457 27.53 17.5187 27.123 17.1002",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3594 12.8164H18.3392",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8438 12.9766V17.8452",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3516 21.668H44.7894",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3516 24.4688H37.2725",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3743 26.6756H8.00617C7.45262 26.6756 7.00391 26.2574 7.00391 25.7414V22.6021C7.00391 22.0862 7.45262 21.668 8.00617 21.668H11.3743C11.9278 21.668 12.3765 22.0862 12.3765 22.6021V25.7414C12.3765 26.2574 11.9277 26.6756 11.3743 26.6756Z",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3516 30.0742H44.7894",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3516 32.875H37.2725",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3743 35.0819H8.00617C7.45262 35.0819 7.00391 34.6636 7.00391 34.1477V31.0084C7.00391 30.4924 7.45262 30.0742 8.00617 30.0742H11.3743C11.9278 30.0742 12.3765 30.4924 12.3765 31.0084V34.1477C12.3765 34.6636 11.9277 35.0819 11.3743 35.0819Z",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3516 38.4824H44.7894",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3516 41.2832H37.2725",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3743 43.4901H8.00617C7.45262 43.4901 7.00391 43.0718 7.00391 42.5559V39.4166C7.00391 38.9007 7.45262 38.4824 8.00617 38.4824H11.3743C11.9278 38.4824 12.3765 38.9007 12.3765 39.4166V42.5559C12.3765 43.0718 11.9277 43.4901 11.3743 43.4901Z",
    stroke: "#F3F7FB",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskOverview);
export default __webpack_public_path__ + "static/media/TaskOverview.37db2516be59f04d9e128c89d386e378.svg";
export { ForwardRef as ReactComponent };